import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

/**
 * TABLE PITCHER
 */
function Pitcher() {
  return (
    <Crud
      title="Pitcher"
      getUrl={() => "/Game/Pitcher_GetList"}
      // INSERT
      insertUrl={() => "/Game/Pitcher_Insert"}
      insertParams={({ userId }, { pitcherName }) => ({
        PitcherName: pitcherName,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Game/Pitcher_Update"}
      updateParams={({ userId }, { idPitcher, pitcherName }) => ({
        IdPitcher: idPitcher,
        PitcherName: pitcherName,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Game/Pitcher_Delete"}
      deleteParams={({ userId }, id) => ({
        IdPitcher: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idPitcher"
      >
        IdPitcher
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="pitcherName"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Pitcher Name
      </TableHeaderColumn>
    </Crud>
  );
}

export default Pitcher;
